exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column}:host .category-seperator:not(:last-child){display:flex;height:.06rem;background-color:#000;opacity:.125;margin:1.5rem 0}:host .back-to-top{position:fixed;bottom:.7rem;right:.7rem;display:flex;align-self:flex-end;background-color:#00142e;padding-bottom:10px;padding-top:8px;color:#fff;font-weight:700;border:none}:host .back-to-top:hover{background-color:#093c7e}:host .back-to-top:focus{outline-offset:2px;outline:2px solid #2087c8;box-shadow:none;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/faq/faq.component.scss
// module id = 691
// module chunks = 0